import React, { useState, useEffect, createRef, forwardRef } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { PropertyList } from "../common/PropertyBox";
import Config from "config";
import { postApiDataAsync, kloader, getCookie, setCookie } from "../common/Common";
import "./index.css";
import { Provider } from "react-redux";
import configureStore from "../store";
import { LoginFooter } from "../common/LoginFooter";

const store = configureStore();

// axios.defaults.headers.common['Authorization'] = store.getState().Token;
//process.env.API_ROOT_URL

const pagesLink = Config.pagesLink;

const App = () => {
  const dataTable = createRef(null);
  const [PromotionProperties, setPromotionProperties] = useState([]);
  const [HotProperties, setHotProperties] = useState([]);
  const [NewProperties, setNewProperties] = useState([]);

  const [showPromoOrNew, setShowPromoOrNews] = useState(true);

  useEffect(() => {
    kloader();

    var SaleFirstDateFrom = new Date();

    // minus days
    SaleFirstDateFrom.setDate(SaleFirstDateFrom.getDate() - 30);
    // SaleFirstDateFrom = SaleFirstDateFrom.format("yyyy-MM-dd")

    var homePromo = getCookie("homePromo");
    var homeHot = getCookie("homeHot");

    if (homePromo) {
      homePromo = homePromo.split(",");
    }

    if (homeHot) {
      homeHot = homeHot.split(",");
    }

    console.log(homePromo, homeHot);

    var getPromo;
    if (homePromo) {
      getPromo = postApiDataAsync({
        urlPath: "/GetProperties",
        objRequest: {
          filter: {
            CurrentPageIndex: 1,
            PageSize: 10,
            PropertyIds: homePromo,
          },
        },
      });
    } else {
      getPromo = postApiDataAsync({
        urlPath: "/GetProperties",
        objRequest: {
          filter: {
            CurrentPageIndex: 1,
            PageSize: Config.MaxPropertyReturnCountBeforeRandom,
            PropertyTypes: ["02", "01", "03", "05"],
            SearchPurposes: ["Promotion30PercentUp"],
            // SourceCodes: ["88"],
            SourceSaleTypes: ["kbank"],
          },
        },
      });
    }

    var getHot;
    if (homeHot) {
      getHot = postApiDataAsync({
        urlPath: "/GetProperties",
        objRequest: {
          filter: {
            CurrentPageIndex: 1,
            PageSize: 10,
            PropertyIds: homeHot,
          },
        },
      });
    } else {
      getHot = postApiDataAsync({
        urlPath: "/GetProperties",
        objRequest: {
          filter: {
            CurrentPageIndex: 1,
            Ordering: "Hot",
            PageSize: Config.MaxPropertyReturnCountBeforeRandom,
            PropertyTypes: ["02", "01", "03", "05"],
            // "Provinces": ["10", "12", "13", "11", "73", "50", "20", "40", "30", "83", "74"],
            // "PMStatus": "NoEncroach",
            SearchPurposes: ["Hot", "HilightProperties"],
            // SourceCodes: ["88"],
            SourceSaleTypes: ["kbank"],
          },
        },
      });
    }

    var getNew = postApiDataAsync({
      urlPath: "/GetProperties",
      objRequest: {
        filter: {
          CurrentPageIndex: 1,
          PageSize: Config.MaxPromoPropertyReturnCount,
          PropertyTypes: ["02", "01", "03", "05"],
          Ordering: "New",
          // SearchPurposes: ["NewProperties"],
          // SaleFirstDateFrom: SaleFirstDateFrom.format("yyyy-MM-ddT00:00:00"),
          // SourceCodes: ["88"],
          SourceSaleTypes: ["kbank"],
        },
      },
    });

    Promise.all([getPromo, getHot, getNew])
      .then((data) => {
        console.log(data);

        var promoData = randomGetNItem(data[0]?.Items || []);
        var hotData = randomGetNItem(data[1]?.Items || []);
        var NewData = data[2]?.Items || [];

        setPromotionProperties(promoData);
        setHotProperties(hotData);
        setNewProperties(NewData);

        if (promoData.length > 0 && !getCookie("homePromo")) {
          setCookie("homePromo", promoData.map((x) => x.PropertyID).join(","), 4 / 24);
        }

        if (hotData.length > 0 && !getCookie("homeHot")) {
          setCookie("homeHot", hotData.map((x) => x.PropertyID).join(","), 4 / 24);
        }

        if (!promoData.length && NewData.length) {
          $("#property-promo").addClass("hide");
          $(".nav.asset-nav li:not(.hide) button").click();
        } else if (promoData.length && !NewData.length) {
          $("#property-new").addClass("hide");
        } else if (!promoData.length && !NewData.length) {
          $("#property-promo").addClass("hide");
          $(".nav.asset-nav li:not(.hide) button").click();
        }
      })
      .catch(function (error) {
        console.log(error);
        // alertErrorAsync(error);
      })
      .then(() => {
        kloader();
      });

    //correct โปรโมชั่นล่าสุด ดูทั้งหมด
    document.querySelectorAll("#promotions .promotion-wrapper a").forEach(function (item) {
      item.addEventListener("click", function (e) {
        dataLayer.push({
          event: "track_event",
          event_category: "link_click",
          event_action: "click",
          event_label: "โปรโมชั่นล่าสุด_" + e.target.innerText,
        });
      });
    });
    //correct รบกวนทีม ICWEB ใส่ alt ที่เป็นชื่อ Promotion ด้วยครับ
    document.querySelectorAll("#promotions .promotion-container a").forEach(function (item) {
      item.addEventListener("click", function (e) {
        dataLayer.push({
          event: "track_event",
          event_category: "link_click",
          event_action: "click",
          event_label: "โปรโมชั่นล่าสุด_" + e.target.getAttribute("alt"),
        });
      });
    });

    //ทรัพย์ยอดนิยม ดูทั้งหมด
    document.querySelectorAll("#property-popular > div:nth-child(1) a").forEach(function (item) {
      item.addEventListener("click", function (e) {
        dataLayer.push({
          event: "track_event",
          event_category: "link_click",
          event_action: "click",
          event_label: "ทรัพย์ยอดนิยม_" + e.target.innerText,
        });
      });
    });

    //correct popular property
    document
      .querySelectorAll("#property-popular > div:nth-child(2) .swiper-slide a")
      .forEach(function (item) {
        item.addEventListener("click", function (e) {
          dataLayer.push({
            event: "track_event",
            event_category: "link_click",
            event_action: "click",
            event_label:
              "ทรัพย์ยอดนิยม_" +
              e.target.closest(".md-thumbnail-slide").querySelector(".asset-code").innerText,
          });
        });
      });

    //correct
    //ทรัพย์ยอดนิยม ดูทั้งหมด
    document.querySelectorAll("#property-popular > div:nth-child(4) a").forEach(function (item) {
      item.addEventListener("click", function (e) {
        dataLayer.push({
          event: "track_event",
          event_category: "link_click",
          event_action: "click",
          event_label: "ทรัพย์โปรโมชั่น_" + e.target.innerText,
        });
      });
    });

    //correct promotion property
    document.querySelectorAll("#property-promo-tab .swiper-wrapper a").forEach(function (item) {
      item.addEventListener("click", function (e) {
        dataLayer.push({
          event: "track_event",
          event_category: "link_click",
          event_action: "click",
          event_label:
            "ทรัพย์โปรโมชั่น_" +
            e.target.closest(".md-thumbnail-slide").querySelector(".asset-code").innerText,
        });
      });
    });

    //โปรโมชั่นล่าสุด ถูกใจ
    document
      .querySelectorAll("#property-promo-tab .property-favorite")
      .forEach(function (item, index) {
        item.addEventListener("click", function (e) {
          if (!item.classList.contains("active"))
            dataLayer.push({
              event: "track_event",
              event_category: "NPA-MAIN-2022",
              event_action: "click",
              event_label:
                "ถูกใจ ทรัพย์โปรโมชั่น_" +
                document.querySelectorAll("#property-promo-tab .wrap-asset-title .asset-title")[
                  index
                ].innerHTML +
                " " +
                document.querySelectorAll("#property-promo-tab .wrap-address .asset-code")[index]
                  .innerHTML,
            });
        });
      });

    //ทรัพย์ยอดนิยม ถูกใจ
    document
      .querySelectorAll(
        "#property-popular .assets-swiper-container .assets-swiper.assets-swiper-1.swiper-initialized .swiper-wrapper .property-favorite"
      )
      .forEach(function (item, index) {
        item.addEventListener("click", function (e) {
          if (!item.classList.contains("active"))
            dataLayer.push({
              event: "track_event",
              event_category: "NPA-MAIN-2022",
              event_action: "click",
              event_label:
                "ถูกใจ ทรัพย์ยอดนิยม_" +
                document.querySelectorAll(".wrap-asset-title .asset-title")[index].innerHTML +
                " " +
                document.querySelectorAll(".wrap-address .asset-code")[index].innerHTML,
            });
        });
      });
  }, []);

  function randomGetNItem(array) {
    if (array && array.length > Config.MaxPromoPropertyReturnCount)
      return array
        .sort(function () {
          return 0.5 - Math.random();
        })
        .slice(0, Config.MaxPromoPropertyReturnCount);
    return array;
  }

  function goToNewOrPromo() {
    let url;
    if ($("#asset-promotion").hasClass("active")) {
      url = pagesLink.promoProperty;
    } else {
      url = pagesLink.NewProperty;
    }
    window.open(url, "_self");
  }

  return (
    <>
      <section id="property-popular" className="assets-section">
        <div className="assets-wrapper">
          <div className="row w-100 mx-auto">
            <div className="col-6 px-0">
              <h2>ทรัพย์แนะนำ</h2>
            </div>
            <div className="col-6 d-flex align-items-center justify-content-end px-0">
              <a href={pagesLink.HotProperty} className="see-all">
                ดูทั้งหมด
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="5"
                  height="8.097"
                  viewBox="0 0 5 8.097"
                >
                  <path
                    id="ic_chevron_right_24px"
                    d="M.951,0,0,.951l3.09,3.1L0,7.146.951,8.1,5,4.049Z"
                    fill="#00a94f"
                  />
                </svg>
              </a>
            </div>
          </div>
          <p class="desc-title">ทรัพย์สินรอการขายยอดนิยม จากทั่วประเทศที่คัดสรรมาให้คุณ</p>
        </div>
        <div className="assets-swiper-container">
          <div className="swiper assets-swiper assets-swiper-1">
            <PropertyList list={HotProperties} />
            <div className="swiper-pagination scroll-pagi assets-pagi-1"></div>
          </div>
          <div
            title="Next"
            className="slick-bt-next swiper-button-next next-btn property-next-1"
          ></div>
          <div
            title="Previous"
            className="slick-bt-back swiper-button-prev prev-btn property-prev-1"
          ></div>
        </div>
        <div className="wrapper wrapper-inner">
          <div className="spacer-line"></div>
        </div>
        <div className="assets-wrapper">
          <div className="d-flex align-items-center justify-content-between max-container">
            <ul className="nav asset-nav" role="tablist">
              <li id="property-promo" className="asset-item" role="presentation">
                <button
                  className="nav-link active"
                  id="asset-promotion"
                  data-bs-toggle="pill"
                  data-bs-target="#property-promo-tab"
                  type="button"
                  role="tab"
                  aria-controls="property-promo-tab"
                  aria-selected="true"
                  onClick={() => {
                    setShowPromoOrNews(true);
                  }}
                >
                  ทรัพย์โปรโมชัน
                </button>
              </li>
              <li id="property-new" className="asset-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#property-new-tab"
                  type="button"
                  role="tab"
                  aria-controls="property-new-tab"
                  aria-selected="false"
                  onClick={() => {
                    setShowPromoOrNews(false);
                  }}
                >
                  ทรัพย์มาใหม่
                </button>
              </li>
            </ul>
            <div
              style={{
                padding: "7px 0",
                borderBottom: "2px solid transparent",
              }}
            >
              {showPromoOrNew && (
                <a href={pagesLink.promoProperty} className="see-all mousePointer">
                  ดูทั้งหมด
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="5"
                    height="8.097"
                    viewBox="0 0 5 8.097"
                  >
                    <path
                      id="ic_chevron_right_24px"
                      d="M.951,0,0,.951l3.09,3.1L0,7.146.951,8.1,5,4.049Z"
                      fill="#00a94f"
                    />
                  </svg>
                </a>
              )}
              {!showPromoOrNew && (
                <a href={pagesLink.NewProperty} className="see-all mousePointer">
                  ดูทั้งหมด
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="5"
                    height="8.097"
                    viewBox="0 0 5 8.097"
                  >
                    <path
                      id="ic_chevron_right_24px"
                      d="M.951,0,0,.951l3.09,3.1L0,7.146.951,8.1,5,4.049Z"
                      fill="#00a94f"
                    />
                  </svg>
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="tab-content" id="pills-tabContent">
          <div
            id="property-promo-tab"
            className="tab-pane fade show active"
            role="tabpanel"
            aria-labelledby="property-promo"
          >
            <div className="assets-swiper-container">
              <div className="swiper assets-swiper assets-swiper-2">
                <p class="desc-title">รวมทรัพย์ราคาพิเศษ ที่ตอบโจทย์ทุกความต้องการ</p>
                <PropertyList list={PromotionProperties} />
                <div className="swiper-pagination scroll-pagi assets-pagi-2"></div>
              </div>
              <div
                title="Next"
                className="slick-bt-next swiper-button-next next-btn property-next-2"
              ></div>
              <div
                title="Previous"
                className="slick-bt-back swiper-button-prev prev-btn property-prev-2"
              ></div>
            </div>
          </div>
          <div
            id="property-new-tab"
            className="tab-pane fade"
            role="tabpanel"
            aria-labelledby="property-new-tab"
          >
            <div className="assets-swiper-container">
              <div className="swiper assets-swiper assets-swiper-3">
                <p class="desc-title">ทรัพย์รอการขายเข้าใหม่ คัด คุ้ม ครบ</p>
                <PropertyList list={NewProperties} />
                <div className="swiper-pagination scroll-pagi assets-pagi-3"></div>
              </div>
              <div
                title="Next"
                className="slick-bt-next swiper-button-next next-btn property-next-3"
              ></div>
              <div
                title="Previous"
                className="slick-bt-back swiper-button-prev prev-btn property-prev-3"
              ></div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Popup Error Message --> */}
      <div id="error-popup" className="popup-error-backdrop">
        <div className="popup-modal">
          <button type="button" id="close-error-popup" className="more-filter-btn error">
            <img
              src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg"
              alt="Close modal"
            />
          </button>
          <div className="popup-inner">
            <p></p>
          </div>
        </div>
      </div>
    </>
  );
};

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("react-app-home")
);

ReactDOM.render(
  <Provider store={store}>
    <LoginFooter />
  </Provider>,
  document.getElementById("react-app-login-footer")
);

if (module.hot) {
  module.hot.accept();
}

console.log("react app property home start");
